import Breakpoints from '@elab/core/utils/Breakpoints';
import constants from '@elab/core/utils/constants';

export const compareExpandedAccordionsGroup = (accordionList, prevAccordionList) => {
    const renderedList = {};
    const accordionListArray = accordionList.split(' ');

    accordionListArray.forEach(key => {
        if (key in prevAccordionList) {
            renderedList[key] = prevAccordionList[key];
        }
    });

    return renderedList;
};

/**
 * @param {HTMLElement} targetElement - the element to which scrolled to
 * @param {number} [shift] - extra space from the top of the visible area
 */
export function scrollToTop({ targetElement, baseElement = window, shift = 0, windowSize }) {
    const { documentElement, body } = window.document;
    const scrollTop = documentElement.scrollTop || body.scrollTop || baseElement.scrollTop || 0;
    const stickyRowElement = document.querySelector('e2-sticky-row');
    const stickyBarElement = document.querySelector('.stickybar');
    const isMobile = Breakpoints.isMobile(windowSize.width);
    const headerHeight = isMobile
        ? constants.headerScrolledHeightMobile
        : constants.headerScrolledHeightDesktop;
    const gap =
        headerHeight +
        (stickyRowElement && !isMobile ? constants.stickyRowHeight : 0) -
        (!stickyBarElement && !isMobile ? constants.stickyBarHeight : 0);

    baseElement.scrollTo({
        top: targetElement.getBoundingClientRect().top + scrollTop - gap - shift,
        behavior: 'smooth',
    });
}
